import { ObjectValues } from "../utils"

export interface RegistrationFormFields {
  title: string
  firstName: string
  lastName: string
  addressId: string
  phone: string
  address1: string
  address2?: string
  city: string
  stateCode: string
  country: string
  postalCode: string
  preferred: boolean
  email: string
  password: string
  searchForAddress?: string
  bonusCardInfo?: string | undefined
  receiveBonusCard?: boolean
  marketingCommunications?: string
  marketingChannels?: Array<{
    label: string
    name: string
    value: ChannelPreference
  }>
  global?: string
  deviceCode?: string
}

export type ChannelPreference = 'Opt In' | 'Opt Out' | 'Not Set'

export const MarketingCommunications = {
  OPT_IN: 'Opt In',
  OPT_OUT: 'Opt Out',
  NOT_SET: 'Not Set'
}

export type MarketingCommunications = ObjectValues<typeof MarketingCommunications>

export const BonusCardType = {
  OPT_IN: 'Opt In',
  OPT_OUT: 'Opt Out'
}

export type BonusCardType = ObjectValues<typeof BonusCardType>